import * as types from "store/actions/input/exposure/hazardActionTypes";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";

export const INIT_STATE = {};

const hazardProfileReducer = (state, action) => {
  if (state === undefined) {
    state = INIT_STATE;
  }
  switch (action.type) {
    case persistenceActionTypes.LOAD_SUBMISSION_STARTED:
      return {
        ...INIT_STATE,
      };
    case persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED:
      return {
        ...INIT_STATE,
        ...action?.payload?.data?.state?.input?.exposures?.hazardProfile,
      };
    case types.ADD_HAZARD_FILE:
      return {
        ...state,
        files: [...(state.files ?? []), action.payload],
      };
    case types.HIDE_HAZARD_FILE:
      return {
        ...state,
        files: (state.files ?? []).filter(
          (fileId) => fileId !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default hazardProfileReducer;
